<template>
  <div class="equipEmission" ref="equipEmission">
    <div class="tab">
      <a class="home_tab" v-for="(item, i) in selectArr" :key="i" :class="{ home_tab_actived: selectIndex == i + 1 }" @click.stop="handleItem(i + 1)">{{ item.name }}</a>
      <el-select v-model="optionIndex" filterable placeholder="请选择" @change="change()">
        <el-option v-for="(item, i) in branchFactoryList" :key="i" :label="item.branch" :value="item.index">
        </el-option>
      </el-select>
    </div>
    <div class="innerBox">
      <div class="charts">
        <!--div class="chart1" v-if="lineType">
          <div class="chart_line" ref="chart1"></div>
        </div-->
        <div class="chart2">
          <div class="chart_column" ref="chart2"></div>
        </div>
      </div>
      <div class="allCount">
        <div class="bg absolute_center"></div>
        <div class="circle"></div>
        <div class="today_all_count absolute_center">
          <div class="div1" v-text="getStaticType()"></div>
          <div class="div2 number">{{ "nox:" + (allCountNox.toFixed && allCountNox.toFixed() || 0) }}</div>
          <div class="div2 number">{{ "so2:" + (allCountSo2.toFixed && allCountSo2.toFixed() || 0) }}</div>
          <div class="div2 number">{{ "tdc:" + (allCountTdc.toFixed && allCountTdc.toFixed() || 0)}}</div>
          <!--div class="div3">次</div-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getOptLine from "./chartLine.js";
import getOptBar from "./chartBar.js";
import { unwarp } from "@/utils/tools.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  props: ["matrix", "x", "y"],
  data() {
    //这里存放数据
    return {
      pageInfo: 'equipEmission.vue',
      computedName: '有组织排放量统计组件',
      styleType: "",
      allCountNox: 0,
      allCountSo2: 0,
      allCountTdc: 0,
      unit: 2,
      customerId: this.$store.state.customerId,
      chart2: null,
      selectIndex: 0,
      selectArr: [
        { name: "日" },
        { name: "周" },
        { name: "月" },
        { name: "年" },
      ],
      optionIndex: "",
      options: [
        { name: "生产设备", num: 1 },
        { name: "治理设备", num: 2 },
      ],
      branchFactoryList: [],
      changeTimer: null,
    };
  },
  //计算属性 类似于data概念
  computed: {
    getStaticType() {
      return function () {
        let typeName = "";
        if (this.selectIndex === 1) {
          typeName = "日累计";
        } else if (this.selectIndex === 2) {
          typeName = "周累计";
        } else if (this.selectIndex === 3) {
          typeName = "月累计";
        } else if (this.selectIndex === 4) {
          typeName = "年累计";
        }
        return typeName;
      };
    },
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
  },
  //监控data中的数据变化
  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal;
        this.typeChange();
      },
      deep: true,
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.styleType = this.$store.state.styleType;
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // this.getOptions();
    this.getOptions2()
    let that = this;
    let w = $(that.$refs.equipEmission).outerWidth();
    let h = $(that.$refs.equipEmission).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.handleItem(1);
    this.typeChange();
  },
  //方法集合
  methods: {
    getOptions() {
      let that = this;
      let findRegionalRankingUrl =
        CONFIG.requestName + this.$apiOpt.findRegionalRanking;
      this.$apiUtils
        .get(findRegionalRankingUrl, {
          customerId: this.$store.state.customerId,
          type: "",
        })
        .then(function (data) {
          data.forEach((item) => {
            item.index = item.branch;
          });
          data.unshift({
            index: "",
            branch: "全部",
          });
          that.branchFactoryList = data;
          if (data.length > 0) {
            that.optionIndex = data[0]["index"];
          }
        });
    },
    getOptions2() {
      let that = this;
      that.branchFactoryList = [
        {
          index: "",
          branch: "全部",
        }
      ]
      let getBranchByCemsUrl =
        CONFIG.requestName + this.$apiOpt.getBranchByCems;
      this.$apiUtils
        .get(getBranchByCemsUrl, {
          customerId: this.$store.state.customerId,
          type: "",
        })
        .then(function (data) {
          Object.keys(data).forEach((key) => {
            let obj = {
              branchId: key,
              branch: data[key],
              index: data[key],
            }
            that.branchFactoryList.push(
              obj
            )
          })
          if (data.length > 0) {
            that.optionIndex = data[0]["index"];
          }
        });
    },
    handleItem(index) {
      if (this.changeTimer) {
        clearTimeout(this.changeTimer)
        this.changeTimer = null
      }
      this.selectIndex = index
      this.getData()
    },
    autoChange() {
      if (this.selectIndex > 3) {
        this.selectIndex = 0
      }
      this.selectIndex += 1
      this.handleItem(this.selectIndex)
    },
    async getData() {
      let that = this;
      let emissionsUrl = CONFIG.requestName + this.$apiOpt.emissions;
      let data = await that.$apiUtils.get(emissionsUrl, {
        customerId: that.$store.state.customerId, //that.customerId,
        branchFactory: that.optionIndex,
        timeType: that.selectIndex,
      });
      let sumTimeNox = data?.noxSum || 0;
      this.allCountNox = parseFloat(sumTimeNox);
      let sumTimeSo2 = data?.so2Sum || 0;
      this.allCountSo2 = parseFloat(sumTimeSo2);
      let sumTimeTdc = data?.tdcSum || 0;
      this.allCountTdc = parseFloat(sumTimeTdc);
      let runTimeList = data?.list || [];
      if (that.selectIndex === 1) {
        let result = that.convertListByHour2(runTimeList);
        if (that.chart2 && that.chart2.dispose) {
          that.chart2.dispose();
        }
        that.chart2 = echarts.init(that.$refs.chart2);
        unwarp(that.chart2).setOption(getOptBar(result));
      } else if (that.selectIndex === 2) {
        let result = that.convertListByWeek(runTimeList);
        if (that.chart2 && that.chart2.dispose) {
          that.chart2.dispose();
        }
        that.chart2 = echarts.init(that.$refs.chart2);
        unwarp(that.chart2).setOption(getOptBar(result));
      } else if (that.selectIndex === 3) {
        let result = that.convertListByMonth(runTimeList);
        if (that.chart2 && that.chart2.dispose) {
          that.chart2.dispose();
        }
        that.chart2 = echarts.init(that.$refs.chart2);
        unwarp(that.chart2).setOption(getOptBar(result));
      } else if (that.selectIndex === 4) {
        let result = that.convertListByYear(runTimeList);
        if (that.chart2 && that.chart2.dispose) {
          that.chart2.dispose();
        }
        that.chart2 = echarts.init(that.$refs.chart2);
        unwarp(that.chart2).setOption(getOptBar(result));
      }
      this.changeTimer = setTimeout(() => this.autoChange(), 8 * 1000)
    },
    convertListByHour(list) {
      let resultTdc = {
        "0:00": 0,
        "4:00": 0,
        "8:00": 0,
        "12:00": 0,
        "16:00": 0,
        "20:00": 0,
      };
      let resultNox = {
        "0:00": 0,
        "4:00": 0,
        "8:00": 0,
        "12:00": 0,
        "16:00": 0,
        "20:00": 0,
      };
      let resultSo2 = {
        "0:00": 0,
        "4:00": 0,
        "8:00": 0,
        "12:00": 0,
        "16:00": 0,
        "20:00": 0,
      };
      let resultObj = {};
      list &&
        list.forEach((element) => {
          let tmpTime = element.time;
          if (tmpTime) {
            let tmpHour = new Date(
              tmpTime.replace(/-0/g, "/").replace(/-/g, "/")
            ).getHours();
            if (tmpHour < 4) {
              resultTdc["0:00"] += parseFloat(element.tdc);
              resultNox["0:00"] += parseFloat(element.nox);
              resultSo2["0:00"] += parseFloat(element.so2);
            } else if (tmpHour < 8) {
              resultTdc["4:00"] += parseFloat(element.tdc);
              resultNox["4:00"] += parseFloat(element.nox);
              resultSo2["4:00"] += parseFloat(element.so2);
            } else if (tmpHour < 12) {
              resultTdc["8:00"] += parseFloat(element.tdc);
              resultNox["8:00"] += parseFloat(element.nox);
              resultSo2["8:00"] += parseFloat(element.so2);
            } else if (tmpHour < 16) {
              resultTdc["12:00"] += parseFloat(element.tdc);
              resultNox["12:00"] += parseFloat(element.nox);
              resultSo2["12:00"] += parseFloat(element.so2);
            } else if (tmpHour < 20) {
              resultTdc["16:00"] += parseFloat(element.tdc);
              resultNox["16:00"] += parseFloat(element.nox);
              resultSo2["16:00"] += parseFloat(element.so2);
            } else {
              resultTdc["20:00"] += parseFloat(element.tdc);
              resultNox["20:00"] += parseFloat(element.nox);
              resultSo2["20:00"] += parseFloat(element.so2);
            }
          }
        });
      resultObj.time = [];
      resultObj.tdcVal = [];
      resultObj.noxVal = [];
      resultObj.so2Val = [];
      for (let i in resultTdc) {
        resultObj.time.push(i);
        resultObj.tdcVal.push(resultTdc[i]);
        resultObj.noxVal.push(resultNox[i]);
        resultObj.so2Val.push(resultSo2[i]);
      }
      return resultObj;
    },
    convertListByHour2(data) {
      if (!data.length) return { time: [], value: [] }
      let arr = data.slice(-9)
      let returnData = { time: [], noxVal: [], so2Val:[], tdcVal:[] }
      arr.forEach(item => {
        item.time = item.time.split(' ')[1]
        item.time.length > 2 ? "" : item.time += ':00'
        returnData.time.push(item.time)
        returnData.noxVal.push(item.nox)
        returnData.so2Val.push(item.so2)
        returnData.tdcVal.push(item.tdc)
      })
      return returnData
    },
    convertListByWeek(list) {
      /*let weekFirstDay = new Date(
        new Date() - (new Date().getDay() - 1) * 86400000
      ).getTime();*/
      let resultObj = {};
      resultObj.time = [];
      resultObj.tdcVal = [];
      resultObj.noxVal = [];
      resultObj.so2Val = [];
      list.forEach((item) => {
        let key = new Date(item.time.replace(/-0/g, "/").replace(/-/g, "/"));
        resultObj.time.push(key.getMonth() + 1 + "-" + key.getDate());
        resultObj.tdcVal.push(item.tdc);
        resultObj.noxVal.push(item.nox);
        resultObj.so2Val.push(item.so2);
      });
      return resultObj;
    },
    convertListByMonth(list) {
      let year = new Date().getFullYear();
      let month = new Date().getMonth() + 1;
      let week1 = month + "-1";
      let week2 = month + "-8";
      let week3 = month + "-15";
      let week4 = month + "-22";
      let resultTdc = {};
      resultTdc[week1] = 0;
      resultTdc[week2] = 0;
      resultTdc[week3] = 0;
      resultTdc[week4] = 0;
      let resultNox = {};
      resultNox[week1] = 0;
      resultNox[week2] = 0;
      resultNox[week3] = 0;
      resultNox[week4] = 0;
      let resultSo2 = {};
      resultSo2[week1] = 0;
      resultSo2[week2] = 0;
      resultSo2[week3] = 0;
      resultSo2[week4] = 0;
      let resultObj = {};
      list &&
        list.forEach((element) => {
          let tmpTime = element.time;
          if (tmpTime) {
            let tempTs = new Date(
              tmpTime.replace(/-0/g, "/").replace(/-/g, "/")
            ).getTime();
            if (
              tempTs <
              new Date((year + "-" + week2).replace(/-/g, "/")).getTime()
            ) {
              resultTdc[week1] += parseFloat(element.tdc);
              resultNox[week1] += parseFloat(element.nox);
              resultSo2[week1] += parseFloat(element.so2);
            } else if (
              tempTs <
              new Date((year + "-" + week3).replace(/-/g, "/")).getTime()
            ) {
              resultTdc[week2] += parseFloat(element.tdc);
              resultNox[week2] += parseFloat(element.nox);
              resultSo2[week2] += parseFloat(element.so2);
            } else if (
              tempTs <
              new Date((year + "-" + week4).replace(/-/g, "/")).getTime()
            ) {
              resultTdc[week3] += parseFloat(element.tdc);
              resultNox[week3] += parseFloat(element.nox);
              resultSo2[week3] += parseFloat(element.so2);
            } else {
              resultTdc[week4] += parseFloat(element.tdc);
              resultNox[week4] += parseFloat(element.nox);
              resultSo2[week4] += parseFloat(element.so2);
            }
          }
        });
      resultObj.time = [];
      resultObj.tdcVal = [];
      resultObj.noxVal = [];
      resultObj.so2Val = [];
      for (let i in resultTdc) {
        resultObj.time.push(i);
        resultObj.tdcVal.push(resultTdc[i].toFixed(2));
        resultObj.noxVal.push(resultNox[i].toFixed(2));
        resultObj.so2Val.push(resultSo2[i].toFixed(2));
      }
      return resultObj;
    },
    convertListByYear(list) {
      let year = new Date().getFullYear();
      let month = new Date().getMonth() + 1;
      let week1 = "一季度";
      let week2 = "二季度";
      let week3 = "三季度";
      let week4 = "四季度";
      let week1_ = "4-1";
      let week2_ = "7-1";
      let week3_ = "10-1";
      let resultTdc = {};
      resultTdc[week1] = 0;
      resultTdc[week2] = 0;
      resultTdc[week3] = 0;
      resultTdc[week4] = 0;
      let resultNox = {};
      resultNox[week1] = 0;
      resultNox[week2] = 0;
      resultNox[week3] = 0;
      resultNox[week4] = 0;
      let resultSo2 = {};
      resultSo2[week1] = 0;
      resultSo2[week2] = 0;
      resultSo2[week3] = 0;
      resultSo2[week4] = 0;
      let resultObj = {};
      list &&
        list.forEach((element) => {
          let tmpTime = element.time;
          if (tmpTime) {
            let tempTs = new Date(
              tmpTime.replace(/-0/g, "/").replace(/-/g, "/")
            ).getTime();
            if (
              tempTs <
              new Date((year + "-" + week1_).replace(/-/g, "/")).getTime()
            ) {
              resultTdc[week1] += parseFloat(element.tdc);
              resultNox[week1] += parseFloat(element.nox);
              resultSo2[week1] += parseFloat(element.so2);
            } else if (
              tempTs <
              new Date((year + "-" + week2_).replace(/-/g, "/")).getTime()
            ) {
              resultTdc[week2] += parseFloat(element.tdc);
              resultNox[week2] += parseFloat(element.nox);
              resultSo2[week2] += parseFloat(element.so2);
            } else if (
              tempTs <
              new Date((year + "-" + week3_).replace(/-/g, "/")).getTime()
            ) {
              resultTdc[week3] += parseFloat(element.tdc);
              resultNox[week3] += parseFloat(element.nox);
              resultSo2[week3] += parseFloat(element.so2);
            } else {
              resultTdc[week4] += parseFloat(element.tdc);
              resultNox[week4] += parseFloat(element.nox);
              resultSo2[week4] += parseFloat(element.so2);
            }
          }
        });
      resultObj.time = [];
      resultObj.tdcVal = [];
      resultObj.noxVal = [];
      resultObj.so2Val = [];
      for (let i in resultTdc) {
        resultObj.time.push(i);
        resultObj.tdcVal.push(resultTdc[i]);
        resultObj.noxVal.push(resultNox[i]);
        resultObj.so2Val.push(resultSo2[i]);
      }
      return resultObj;
    },
    change() {
      this.getData();
    },
    typeChange() {
      if (this.styleType == "typeGreen") {
        this.$nextTick(() => {
          $(".equipEmission .tab").css("margin-top", "20px");
          $(".equipEmission .innerBox").css("height", "170px");
        });
      } else if (this.styleType == "typeDark") {
        this.$nextTick(() => {
          $(".equipEmission .tab").css("margin-top", "initial");
          $(".equipEmission .innerBox").css("height", "180px");
        });
      }
    },
  },
  unmounted() {
    if (this.chart2) {
      this.chart2.dispose();
      this.chart2 = null;
    }
  },
};
</script>
<style lang="scss" scoped="scoped">
.equipEmission {
  width: 600px;
  height: 250px;
  .tab {
    justify-content: flex-end;
    z-index: 1;
    display: flex;
    .el-select {
      width: 125px;
      height: 26px;
    }
  }
  .innerBox {
    @include bg-box(560px, 180px, "imgBg.png");
    display: flex;
    margin-top: 6px;
    padding-left: 10px;

    .charts {
      width: 340px;
      height: 100%;
      margin-right: 10px;
      // padding: 20px 0px 0px;
      .chart1 {
        width: 100%;
        height: 100%;
        .chart_line {
          width: 100%;
          height: 100%;
        }
      }
      .chart2 {
        width: 100%;
        height: 100%;
        .chart_column {
          width: 100%;
          height: 100%;
        }
      }
    }
    .allCount {
      width: 200px;
      height: 100%;
      position: relative;
      .bg {
        position: absolute;
        @include bg-box(90px, 92px, "flowerBg.png");
      }
      .circle {
        @include bg-box(164px, 164px, "circle.png");
        top: 7px;
        left: 18px;
        position: absolute;
      }
      @keyframes rotate {
        0% {
          transform: rotate(0deg);
        }
        50% {
          transform: rotate(-180deg);
        }
        100% {
          transform: rotate(-360deg);
        }
      }
      .today_all_count {
        width: 90px;
        height: 85px;
        text-align: center;
        padding-top: 5px;
        .div1 {
          width: 100%;
          font-size: 14px;
          color: #b8b8b8;
          margin-bottom: 5px;
        }
        .div2 {
          width: 100%;
          height: 18px;
          font-size: 16px;
          color: #99f5ff;
          line-height: 18px;
          overflow: hidden;
        }
        .div3 {
          width: 100%;
          font-size: 14px;
          color: #b8b8b8;
        }
      }
    }
  }
}
</style>
<style>
.equipEmission .el-select .select-trigger .el-input .el-input__suffix-inner .el-icon-arrow-up {
  line-height: 26px;
}
.equipEmission .el-select {
  margin-left: 5px;
  height: 26px;
}
.equipEmission .el-select .select-trigger {
  height: 26px !important;
}
.equipEmission .el-select .select-trigger .el-input {
  height: 26px;
}
.equipEmission .el-select .select-trigger .el-input .el-input__inner {
  height: 26px !important;
}
.equipEmission .el-select .select-trigger .el-input .el-input__suffix-inner {
  display: flex;
}
.equipEmission .el-select .select-trigger .el-input .el-input__suffix-inner .el-icon-arrow-up {
  line-height: 26px;
}

.equipEmission .home_tab {
  margin-left: 10px;
}

.equipEmission .typeBlue .el-select {
  margin-left: 5px;
  height: 26px;
}
.equipEmission .typeBlue.el-select .select-trigger {
  height: 26px !important;
}
.equipEmission .typeBlue .el-select .select-trigger .el-input {
  height: 26px;
}

.equipEmission .typeBlue .el-input__suffix {
  margin-top: 8px;
}
</style>
